import React from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

const ViewProviderDetailsGender = ({ gender, showLabel = false }) => {
  const { t } = useTranslation();

  const getGender = (genderVal) => {
    if (genderVal == "M") {
      return t(`male`);
    }
    if (genderVal == "F") {
      return t(`female`);
    }
    if (genderVal == "U") {
      return t(`n/a`);
    }
  };

  return (
    <>
      {showLabel ? (
        <label className="left-align"> {t(`Gender`)}:</label>
      ) : (
        <>
          <span className="details-subheader">{t(`Gender`)}:</span>
          <br />
        </>
      )}
      <span>&nbsp;{getGender(gender)}</span>
    </>
  );
};

ViewProviderDetailsGender.propTypes = {
  gender: PropTypes.string,
  showLabel: PropTypes.boolean,
};

export default ViewProviderDetailsGender;
